import { render } from "./customizeHomework.vue?vue&type=template&id=0ce18dc2&scoped=true"
import script from "./customizeHomework.vue?vue&type=script&lang=js"
export * from "./customizeHomework.vue?vue&type=script&lang=js"

import "./customizeHomework.vue?vue&type=style&index=0&id=0ce18dc2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ce18dc2"]])

export default __exports__